var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"8","viewBox":"0 0 24 8","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M12 0L24 8H0L12 0Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }